export default function Footer() {
  return <footer>&copy; {new Date().getFullYear()} made with &hearts;  rajshree.space</footer>;
}
